import * as menu from '@zag-js/menu';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track, Portal } from 'ripple';
import { ChevronDown } from 'lucide-ripple';

export component Menu() {
	let service = useMachine(menu.machine, {
		id: 'menu',
	});
	let api = track(() => menu.connect(service, normalizeProps));

	<button {...@api.getTriggerProps()}>
		{'Actions'}
		<span {...@api.getIndicatorProps()}>
			<ChevronDown />
		</span>
	</button>
	<Portal target={document.body}>
		<div {...@api.getPositionerProps()}>
			<ul {...@api.getContentProps()}>
				for (const item of data) {
					<li {...@api.getItemProps({ value: item.value })}>{item.label}</li>
				}
			</ul>
		</div>
	</Portal>
}

const data = [
	{ value: 'edit', label: 'Edit' },
	{ value: 'duplicate', label: 'Duplicate' },
	{ value: 'archive', label: 'Archive' },
	{ value: 'delete', label: 'Delete' },
];
